<template>
    <div class="row align-items-start g-0 mb-2">
        <div class="col-md-6">
            <div class="d-flex align-items-center">
                <span class="me-2">De</span>
                <input type="number" class="form-control form-control-sm me-2" min="0" max="255" :value="parity.start" @input="updateStart($event.target.value)" />
            </div>
                <div v-if="startError" class="custom-error-msg">{{ startError }}</div>
        </div>
        <div class="col-md-6">
            <div class="d-flex align-items-center">
                <span class="me-2">A</span>
                <input type="number" class="form-control form-control-sm" min="0" max="255" :value="parity.end" @input="updateEnd($event.target.value)" />
            </div>
            <div v-if="endError" class="custom-error-msg">{{ endError }}</div>
        </div>
    </div>
    <select class="form-select mb-2" :value="parity.parity_type" @input="updateType($event.target.value)">
        <option value="Even">Paire</option>
        <option value="Odd">Impaire</option>
    </select>
</template>

<script>
import Parity from '@/models/parity';

export default {
    name: 'ParityComponent',
    props: {
        parity: {
            type: Parity,
            required: true
        },
    },
    emits: ['update:parity'],
    data() {
        return {
            startError: "",
            endError: "",
        };
    },
    methods: {
        updateStart(value) {
            this.$emit('update:parity', 
                new Parity(true, Number(value), this.parity.end, this.parity_type)
            );
        },
        updateEnd(value) {
            this.$emit('update:parity', 
                new Parity(true, this.parity.start, Number(value), this.parity_type)
            );
        },
        updateType(value) {
            this.$emit('update:parity', 
                new Parity(true, this.parity.start, this.parity.end, value)
            );
        },
        validate(size) {
            this.startError = "";
            this.endError = "";

            if(this.parity.start == 0 || this.parity.start > size) {
                this.startError = `Doit être compris entre 1 et ${size}`;
            }
            if(this.parity.end == 0 || this.parity.end > size) {
                this.endError = `Doit être compris entre 1 et ${size}`;
            }

            if(this.startError || this.endError) return false;

            if(this.parity.start >= this.parity.end) {
                this.startError = `Doit être inférieur à ${this.parity.end}`;
                return false;
            }
            return true;
        },
        reset() {
            this.startError = "";
            this.endError = "";
        },
    }
};
</script>

<style scoped>
.custom-error-msg {
    color: red;
    font-size: 14px;
}
</style>
